module.exports = __webpack_public_path__ + "img/card chip.61383bf6.svg";